<template>
  <div class="page-counter d-flex justify-content-center mt-2">
    <template v-if="isFiltered">
      {{ filteredCount }} из {{ totalCount }} {{ getPluralForm() }}
    </template>
    <template v-else>
      {{ totalCount }} {{ getPluralForm() }}
    </template>
  </div>
</template>

<script>
export default {
  name: "PageCounter",
  props: {
    isFiltered: {
      type: Boolean,
      default: false
    },
    totalCount: {
      type: Number,
      default: 0
    },
    filteredCount: {
      type: Number,
      default: 0
    },
  },
  methods: {
    getPluralForm() {
      let isTen = Math.trunc((this.totalCount - Math.trunc(this.totalCount / 100) * 100) / 10) == 1;
      if (isTen)
        return "записей";

      let lastDigit = this.totalCount - Math.trunc(this.totalCount / 10) * 10;
      if (lastDigit == 1)
          return this.isFiltered ? "записи" : "запись";
      else
        if (lastDigit > 1 && lastDigit < 5 && !this.isFiltered)
          return "записи";
        else
          return "записей";
    }
  }
}
</script>

<style lang="scss" scoped>
.page-counter {
  color: #777
}
</style>